import Vue from 'vue'
import BPCore from '@/utils/burying-point/bp-core'

Vue.mixin({
  methods: {
    /**
     * 埋点事件
     * @param event 埋点事件
     * @param extra 额外参数
     */
    bpSend(event, extra) {
      BPCore.send(event, extra)
    }
  }
})
